'use client'

import { useAuth } from '@clerk/nextjs'
import Link from 'next/link'
import { useState } from 'react'
import { Icon } from '@/components/icon'
import { Button } from '@/components/ui/button'
import { SignUpModal } from '@/features/auth'
import { capture } from '@/features/tracking'
import { getWatchPathSegment } from '@/features/video'

interface PlayButtonProps {
  videoId: string
}

export function PlayButton({ videoId }: PlayButtonProps) {
  const { isSignedIn } = useAuth()
  const [showSignUp, setShowSignUp] = useState(false)
  const watchSlug = getWatchPathSegment(videoId)
  const watchUrl = `/watch/${watchSlug}`

  const handleClick = (e: React.MouseEvent) => {
    if (!isSignedIn) {
      e.preventDefault()
      setShowSignUp(true)
    }
  }

  return (
    <>
      <Link
        href={watchUrl}
        onClick={handleClick}
        className='relative top-9 transition-all duration-300 ease-out hover:scale-110'
      >
        <Icon name='play-fill-alt' className='size-14 max-w-22 md:size-20' />
      </Link>
      <SignUpModal isOpen={showSignUp} onClose={() => setShowSignUp(false)} />
    </>
  )
}

export function PayButton() {
  return (
    <Button
      asChild
      className='ease h-auto w-full overflow-visible whitespace-nowrap bg-christ-white-700 px-10 py-7 text-center font-bold text-[1.5rem] text-christ-black-900 uppercase leading-none tracking-[-0.04rem] transition-all duration-300 hover:bg-christ-white-700 hover:opacity-90 md:px-10 md:py-8 md:pb-6 md:text-[2.25rem]'
    >
      <Link
        href='/pay-it-forward'
        onClick={() => {
          capture('donation:pay_it_forward_modal_view', {
            trigger_point: 'watch',
          })
        }}
      >
        Pay It Forward
      </Link>
    </Button>
  )
}
